export default "__VITE_ASSET__DdRVRct8__"